import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const FilterTableModal = ({
  show,
  onClose,
  field,
  options = [],
  activeSelections = [],
  onApply,
  onResetAll,
}) => {
  const [local, setLocal] = useState([]);

  useEffect(() => {
    setLocal(Array.isArray(activeSelections) ? activeSelections : []);
  }, [activeSelections, show]);

  const toggle = (value) => {
    setLocal((prev) => {
      if (prev.includes(value)) return prev.filter((p) => p !== value);
      return [...prev, value];
    });
  };

  const apply = () => {
    onApply(field, local);
    onClose();
  };
  
  const formatFieldLabel = (str) => {
  if (!str) return "";

  return str
    .replace(/([A-Z])/g, " $1")     
    .replace(/^./, (s) => s.toUpperCase()); 
};


  if (!show) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 px-4"
      onClick={onClose}
    >
      <div
        className="bg-white w-[380px] rounded-xl shadow-2xl overflow-hidden animate-fadeIn"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white px-5 py-3 flex justify-between items-center">
          <h3 className="text-lg font-semibold tracking-wide">
            Filter by {formatFieldLabel(field)}
          </h3>
          <button
            onClick={onClose}
            className="hover:bg-white/20 p-1 rounded transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* CONTENT */}
        <div className="max-h-72 overflow-y-auto px-5 py-4 space-y-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          {options.length === 0 && (
            <div className="text-sm text-gray-500">
              No filter options available.
            </div>
          )}

          {options.map((opt) => {
            const checked = local.includes(opt);

            return (
              <label
                key={opt}
                className="flex items-center gap-3 px-2 py-2 rounded-md hover:bg-gray-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggle(opt)}
                  className="form-checkbox h-4 w-4 text-blue-600 rounded-md focus:ring-blue-500"
                />
                <span className="text-sm text-gray-800">{opt || "--"}</span>
              </label>
            );
          })}
        </div>

        {/* FOOTER */}
        <div className="border-t bg-gray-50 px-5 py-3 flex justify-between items-center">
          <div className="flex gap-2">
            <button
              className="px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-200 transition"
              onClick={() => setLocal([])}
            >
              Reset
            </button>
            <button
              className="px-3 py-1.5 text-sm text-red-600 hover:bg-red-100 rounded-md transition"
              onClick={() => {
                onResetAll();
                onClose();
              }}
            >
              Clear All
            </button>
          </div>

          <div className="flex gap-2">
            <button
              className="px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-200 transition"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-3 py-1.5 text-sm bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white rounded-md hover:opacity-90 shadow"
              onClick={apply}
            >
              Apply
            </button>
          </div>
        </div>
      </div>

      {/* ANIMATION */}
      <style>
        {`
        .animate-fadeIn {
          animation: fadeIn 0.25s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        `}
      </style>
    </div>
  );
};

export default FilterTableModal;
